import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiUrl } from '../utils/apiConfig';
import {
  Container, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Button
} from '@mui/material';
import ZuordnenDialog from '../components/ZuordnenDialog';

const ToDoZuzuordnen = () => {
  const [zuordnungen, setZuordnungen] = useState([]);
  const [konten, setKonten] = useState([]);
  const [objekte, setObjekte] = useState([]);
  const [wohneinheiten, setWohneinheiten] = useState([]);
  const [offen, setOffen] = useState(false);
  const [eintrag, setEintrag] = useState(null);

  const ladeDaten = async () => {
    try {
      const [zuRes, koRes, obRes, whgRes] = await Promise.all([
        axios.get(getApiUrl('/api/buchung/offene-zuordnungen')),
        axios.get(getApiUrl('/api/buchungskonten')),
        axios.get(getApiUrl('/api/objects')),
        axios.get(getApiUrl('/api/wohneinheiten')),
      ]);
      setZuordnungen(zuRes.data);
      setKonten(koRes.data);
      setObjekte(obRes.data);
      setWohneinheiten(whgRes.data);
    } catch (err) {
      // Fehler beim Laden der offenen Zuordnungen
    }
  };

  useEffect(() => {
    ladeDaten();
  }, []);

  const handleZuordnen = (eintrag) => {
    setEintrag(eintrag);
    setOffen(true);
  };

  const handleClose = (refresh = false) => {
    setEintrag(null);
    setOffen(false);
    if (refresh) ladeDaten();
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>Offene Zuordnungen</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Verwendungszweck</TableCell>
              <TableCell>Betrag</TableCell>
              <TableCell>Bereits gebucht</TableCell>
              <TableCell>Rest</TableCell>
              <TableCell>Aktion</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {zuordnungen.map((eintrag, index) => (
              <TableRow key={eintrag.id || eintrag.bewegungsid || index}>
                <TableCell>{eintrag.name}</TableCell>
                <TableCell>{parseFloat(eintrag.betrag).toFixed(2)} €</TableCell>
                <TableCell>{parseFloat(eintrag.gebucht).toFixed(2)} €</TableCell>
                <TableCell>{parseFloat(eintrag.restbetrag).toFixed(2)} €</TableCell>
                <TableCell>
                  <Button variant="outlined" onClick={() => handleZuordnen(eintrag)}>Zuordnen</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {eintrag && (
        <ZuordnenDialog
          open={offen}
          onClose={handleClose}
          eintrag={eintrag}
          konten={konten}
          objekte={objekte}
          wohneinheiten={wohneinheiten}
        />
      )}
    </Container>
  );
};

export default ToDoZuzuordnen;
